import { FontSizeOutlined } from '@ant-design/icons';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { type IParagraphWidget } from './IParagraphWidget.ts';
import { ParagraphWidgetComponent } from './ParagraphWidgetComponent.tsx';
import {
  ParagraphWidgetConfigComponent,
  ParagraphWidgetConfigSchema,
} from './ParagraphWidgetConfigComponent.tsx';
import { renderParagraphHtml } from './renderParagraphHtml.ts';

/**
 * Tipo del componente di visualizzazione di un paragrafo.
 */
export const ParagraphWidgetType: IWidgetType<IParagraphWidget> = {
  icon: <FontSizeOutlined />,
  type: WidgetType.Paragraph,
  mainType: WidgetMainType.Graphic,
  category: WidgetCategory.Graphic,
  name: 'Paragrafo',
  hasValue: false,
  formComponent: ParagraphWidgetComponent,
  configComponent: ParagraphWidgetConfigComponent,
  configValidator: ParagraphWidgetConfigSchema,
  previewComponent: ParagraphWidgetComponent,
  translationSchema: tran.widget({
    helpText: tran.rte(),
  }),
  rules: [],
  renderHtml: renderParagraphHtml,
};
